export const CountryList = {
  AsiaPacific: [
    //亚太数据
    {
      name: '中国大陆',
      code: 'CN',
      area_code: '86',
    },
    {
      name: '日本',
      code: 'JP',
      area_code: '81',
    },
    {
      name: '中國澳門',
      code: 'MO',
      area_code: '853',
    },
    {
      name: '中國台灣',
      code: 'TW',
      area_code: '886',
    },
    {
      name: '中國香港',
      code: 'HK',
      area_code: '852',
    },
    {
      name: 'Australia',
      code: 'AU',
      area_code: '61',
    },
    {
      name: 'India',
      code: 'IN',
      area_code: '91',
    },
    {
      name: 'Indonesia',
      code: 'ID',
      area_code: '62',
    },
    {
      name: 'Malaysia',
      code: 'MY',
      area_code: '60',
    },
    {
      name: 'New Zealand',
      code: 'NZ',
      area_code: '64',
    },
    {
      name: 'Philippines',
      code: 'PH',
      area_code: '63',
    },
    {
      name: 'Singapore',
      code: 'SG',
      area_code: '65',
    },
    {
      name: 'Türkiye',
      code: 'TR',
      area_code: '90',
    },
    {
      name: 'Việt Nam',
      code: 'VN',
      area_code: '84',
    },
    {
      name: 'ِسْرَائِيل',
      code: 'IL',
      area_code: '972',
    },
    {
      name: 'الإمارات',
      code: 'AE',
      area_code: '971',
    },
    {
      name: 'العربية السعودية',
      code: 'SA',
      area_code: '966',
    },
    {
      name: 'الكويت‎',
      code: 'KW',
      area_code: '965',
    },
    {
      name: 'جمهوريّة مصرالعربيّة‎',
      code: 'EG',
      area_code: '20',
    },
    {
      name: 'قطر‎',
      code: 'QA',
      area_code: '974',
    },
    {
      // 泰国
      name: 'ประเทศไทย',
      code: 'TH',
      area_code: '66',
    },
    {
      name: '한국',
      code: 'KR',
      area_code: '82',
    },
    {
      name: 'বাংলাদেশ',
      code: 'BD',
      area_code: '880',
    },
  ],
  Europe: [
    //欧洲数据
    {
      name: 'Azərbaycan',
      code: 'AZ',
      area_code: '994',
    },
    {
      name: 'Belgium',
      code: 'BE',
      area_code: '32',
    },
    {
      name: 'Danmark',
      code: 'DK',
      area_code: '45',
    },
    {
      name: 'Deutschland',
      code: 'DE',
      area_code: '49',
    },
    {
      name: 'España',
      code: 'ES',
      area_code: '34',
    },
    {
      name: 'Estonia',
      code: 'EE',
      area_code: '372',
    },
    {
      name: 'Française',
      code: 'FR',
      area_code: '33',
    },
    {
      name: 'Ireland',
      code: 'IE',
      area_code: '353',
    },
    {
      name: 'Italia',
      code: 'IT',
      area_code: '39',
    },
    {
      name: 'Kongeriket Norge',
      code: 'NO',
      area_code: '47',
    },
    {
      name: 'Latvija',
      code: 'LV',
      area_code: '371',
    },
    {
      name: 'Lietuvos Respublika',
      code: 'LT',
      area_code: '370',
    },
    {
      name: 'Magyarország',
      code: 'HU',
      area_code: '36',
    },
    {
      name: 'Nederland',
      code: 'NL',
      area_code: '31',
    },
    {
      name: 'Österreich',
      code: 'AT',
      area_code: '43',
    },
    {
      name: 'Polska',
      code: 'PL',
      area_code: '48',
    },
    {
      name: 'Portuguesa',
      code: 'PT',
      area_code: '351',
    },
    {
      name: 'România',
      code: 'RO',
      area_code: '40',
    },
    {
      name: 'Slovenija',
      code: 'SI',
      area_code: '386',
    },
    {
      name: 'Suomi',
      code: 'FI',
      area_code: '358',
    },
    {
      name: 'Sverige',
      code: 'SE',
      area_code: '46',
    },
    {
      name: 'United Kingdom',
      code: 'GB',
      area_code: '44',
    },
    {
      name: 'Ελλάς',
      code: 'GR',
      area_code: '30',
    },
    {
      name: 'Россия',
      code: 'RU',
      area_code: '7',
    },
    {
      name: 'Schweiz',
      code: 'CH',
      area_code: '41',
    },
    {
      name: 'Lëtzebuerg',
      code: 'LU',
      area_code: '352',
    },
    {
      name: 'Česko',
      code: 'CZ',
      area_code: '420',
    },
    {
      name: 'Slovensko',
      code: 'SK',
      area_code: '421',
    },
    {
      name: 'Hrvatska',
      code: 'HR',
      area_code: '385',
    },
  ],

  America: [
    //其他数据
    {
      name: 'Canada',
      code: 'CA',
      area_code: '1',
    },
    {
      name: 'Chile',
      code: 'CL',
      area_code: '56',
    },
    {
      name: 'Colombia',
      code: 'CO',
      area_code: '57',
    },
    {
      name: 'México',
      code: 'MX',
      area_code: '52',
    },
    {
      name: 'Perú',
      code: 'PE',
      area_code: '51',
    },
    {
      name: 'Puerto Rico',
      code: 'PR',
      area_code: '1787',
    },
    {
      name: 'US',
      code: 'US',
      area_code: '1',
    },
    {
      name: 'Brasil',
      code: 'BR',
      area_code: '55',
    },
    {
      name: 'Argentina',
      code: 'AR',
      area_code: '54',
    },
    {
      name: 'Costa Rica',
      code: 'CR',
      area_code: '506',
    },
  ],
  Africa: [
    //其他数据
    {
      name: 'South Africa',
      code: 'ZA',
      area_code: '27',
    },
  ],
}

export const Pacifics: Array<keyof typeof CountryList> = ['Africa', 'America', 'AsiaPacific', 'Europe']
